// Function to convert the noteRevisionDate to "x time ago" format
export const formatMetaDate = (value) => {
    const date = new Date(value); // Convert the ISO string to a Date object
    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);
    const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });

    // Handle different units of time (seconds, minutes, hours, days, months, years)
    if (seconds < 60) {
        return rtf.format(-seconds, "second");
    }
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) {
        return rtf.format(-minutes, "minute");
    }
    const hours = Math.floor(minutes / 60);
    if (hours < 24) {
        return rtf.format(-hours, "hour");
    }
    const days = Math.floor(hours / 24);
    if (days < 30) {
        return rtf.format(-days, "day");
    }
    const months = Math.floor(days / 30);
    if (months < 12) {
        return rtf.format(-months, "month");
    }
    const years = Math.floor(months / 12);
    return rtf.format(-years, "year");
};


export const convertFormattedDuration = (duration) => {

    let formattedDuration = "";

    if (duration.years || duration.months || duration.days) {
        if (duration.years > 0) {
            formattedDuration += `${duration.years} year${duration.years > 1 ? 's' : ''} `;
        }
        if (duration.months > 0) {
            formattedDuration += `${duration.months} month${duration.months > 1 ? 's' : ''} `;
        }
        if (duration.days > 0) {
            formattedDuration += `${duration.days} day${duration.days > 1 ? 's' : ''}`;
        }
    }

    // Remove trailing space if it exists
    formattedDuration = formattedDuration.trim();
    formattedDuration = formattedDuration ? `${formattedDuration} in` : '';
    return formattedDuration;
}